import {
  IAccrualBenefitTransactionDTO,
  IAccrualBenefitTransactionsRequestDTO,
  IAccrualSummaryBalanceRequestDTO,
  IAccrualSummaryBalanceDTO,
  IAccrualFutureBalanceDTO,
  IAccrualFutureBalanceRequestDTO,
} from 'src/api/dtos';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import api from 'src/api/rtk/rtk-api';
import { IListQueryResult, IQueryResult } from 'src/api/types';

export default class AccrualRepository extends ESSRepository {
  private static readonly baseRoute = '/accruals';
  private static readonly apiURL = this.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getAccrualSummary: build.query<IAccrualSummaryBalanceDTO, IAccrualSummaryBalanceRequestDTO>({
        query: (params) => {
          return { url: `${this.apiURL}/summary`, method: 'get', params };
        },
        providesTags: ['AccrualSummary'],
        transformResponse: (response: IQueryResult<IAccrualSummaryBalanceDTO>) => response.item,
      }),
      getAccrualBenefitTransactions: build.query<
        IAccrualBenefitTransactionDTO[],
        IAccrualBenefitTransactionsRequestDTO
      >({
        query: ({ benefitId, ...params }) => {
          return {
            url: `${this.apiURL}/benefits/${benefitId}/benefittransactions`,
            method: 'get',
            params,
          };
        },
        providesTags: ['AccrualBenefitTransactions'],
        transformResponse: (response: IListQueryResult<IAccrualBenefitTransactionDTO>) => response.items,
      }),
      getFutureAbsences: build.query<IAccrualFutureBalanceDTO[], IAccrualFutureBalanceRequestDTO>({
        query: ({ benefitEmployeeId }) => {
          return {
            url: `${this.apiURL}/benefitemployees/${benefitEmployeeId}/futurescheduledabsences`,
            method: 'get',
          };
        },
        transformResponse: (response: IListQueryResult<IAccrualFutureBalanceDTO>) => response.items,
      }),
    }),
  });
}
